module.exports = __webpack_public_path__ + "static/media/generated-message-show.85b85c27.png";